import * as actionTypes from './actionTypes';

const { LOGIN, LOGOUT, SET_AUTH_STATE } = actionTypes;

const auth = {
  login: ({ commit }, user) => {
    commit(LOGIN, user);
    commit(SET_AUTH_STATE, 'signedIn');
  },
  logout: ({ commit }) => {
    commit(LOGOUT);
  },
  setAuthState: ({ commit }, payload) => {
    commit(SET_AUTH_STATE, payload);
  }
};

export default auth;
